import { Component } from '@builder.io/sdk';

// Content is sourced from the `landing-search-page` data model (filtered by the
// page `urlSlug`), so the component exposes no editable inputs in Builder.
export const config: Component = {
    name: 'Explore Media Library',
    inputs: [],
};
